import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const globalHijack: Example = {
  id: "global-hijack",
  title: "API hooking & pollution",
  group: "technique",
  environment: "browser",
  mode: "script",
  summary: "Wraps fetch and XMLHttpRequest.prototype.open to copy the page's traffic",
  explainer:
    "Overwriting `window.fetch` and `XMLHttpRequest.prototype.open` is recorded the moment it " +
    "happens (GLOBALS events tagged `tamper`) and becomes a critical hooking finding per API. " +
    "The `Object.prototype.isAdmin` assignment can't be seen live; the end-of-run global diff " +
    "catches it as prototype pollution.",
  code,
  expect: golden as Example["expect"],
};
